<template>
  <div>
    <h6 class="booking-details-title">{{ item.label }}</h6>
    <b-card bg-variant="light">
      <b-card-text style="white-space: pre-line;">
        <!-- {{item}} -->
        {{ transferDescription }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'TransferItemInfo',
  props: ['item'],
  data () {
    return {
      description: this.item.description
    }
  },
  computed: {
    transferDescription () {
      return this.description.split(/\r|\n/).splice(0, 1).join('')
    }
  }
}
</script>
